module.exports = __webpack_public_path__ + "static/Hero-mp.202765b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Hero-mp.jpg
// module id = 119
// module chunks = 133428282160390 225901961288281